import { h } from "preact";

import i18n from "../i18n";
import Button from "./Button.jsx";
import HeaderIcon from "./HeaderIcon.jsx";
import TaskLink from "./TaskLink.jsx";
import List from "./List.jsx";
import ListItem from "./ListItem.jsx";
import TaskProgress from "./TaskProgress.jsx";
import { useSelector } from "react-redux";
import { useEffect } from "preact/hooks";
import { sendError } from "../errors";
import { selectTasks } from "../store";

export default function BlockedState({ task, onClose }) {
  const tasks = useSelector(selectTasks);

  function getTaskById(id) {
    return tasks.find((t) => t.id === id);
  }

  const visibleTasks = task.blockingTasks.filter(getTaskById);

  useEffect(() => {
    if (visibleTasks.length === 0) {
      sendError("Tasks in BlockedState are empty", {
        taskId: task.id,
        // FIXME: Does this make sense?
        visibleTasks: tasks.map((t) => t.id === task.id),
      });
    }
  }, [visibleTasks]);

  return (
    <section class="task-page">
      <div class="row">
        <div class="col s12 l6 offset-l2">
          <HeaderIcon>early_bird</HeaderIcon>
          <h1 class="task-page__headline">
            {i18n.t(`component.blocked_state.title`)}
          </h1>

          <div class="task-page__content">
            <p class="t-body3 mb-32">
              {i18n.t(`component.blocked_state.description`)}
            </p>

            <List>
              {visibleTasks.map((id) => (
                <ListItem
                  iconFront={
                    <span>
                      <TaskProgress task={getTaskById(id)} />
                    </span>
                  }
                >
                  {i18n.t(`tasks.${id}.title`)}
                  <TaskLink id={id} class="ml-16" />
                </ListItem>
              ))}
            </List>
          </div>

          <div class="task-page__buttons">
            <Button secondary onClick={onClose}>
              {i18n.t("actions.done")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
